import React, { useEffect, useState, useRef} from 'react';
import { getNodes } from './nodesHelper';
import { buildContentfulLink } from '../../helpers/buildContentfulLink'
import { getDataPathsMetadata, getSpaceId, getEnvironment } from "./globalHelpers"
import ToolTip from 'react-portal-tooltip'
import { v4 as uuidv4 } from 'uuid';

export const DecorateWithContentfulLinks = ({ children, parent, targetNodes, targetPaths, elementName }) => {
 
  const nodes = getNodes(targetNodes, parent, targetPaths);

  const links = getLinksFor(nodes)

  const [isActive, setisActive] = useState(false)
  const ref = useRef(null)

  useEffect(() => {

    if(!ref.current){
      return;
    }
    
    const timeoutId = setTimeout(() => {
      setisActive(links.length > 0)      
    }, 1500);

    return () => {
      clearTimeout(timeoutId)
    }
  }, [ref.current])


  const tooltipStyle = {
    style: {
      background: 'rgba(0,0,0,.8)',
      padding: 10,
      color: "white"
    },
    arrowStyle: {
      color: 'rgba(0,0,0,.8)',
      borderColor: false
    }
  }

  return <>
    <div ref={ref}/>
    {children || <></>}
    {!!ref.current && <ToolTip style={tooltipStyle} active={isActive} group={uuidv4()} useHover={true} position="top" arrow="center" parent={ref.current}>
      {getTooltipContent(links, elementName)}
    </ToolTip>}    
  </>
};

const getLinksFor = (nodes) => {
  const links = []
  const dataPathsMetadata = getDataPathsMetadata()
  const spaceId = getSpaceId()
  const environment = getEnvironment()
  if(dataPathsMetadata && Object.keys(dataPathsMetadata).length){
    nodes.forEach(node => {
      const contentfulId = getContentfulIdFrom(dataPathsMetadata, node)
      const contentfulLink = buildContentfulLink(contentfulId, spaceId, environment)
      if(contentfulLink){
        links.push(contentfulLink)
      }
    });
  }

  return [...new Set(links)]
}

function getTooltipContent(links, elementName) {
  
  if(!links.length){
    return <></>
  }

  if(links.length === 1){
    return <a href={links[0]} target="_blank">{elementName}</a>;
  }

  return <div>
    {elementName}
    <br/>
    {links.map((link, index) => {
      return <>
        <a key={index} href={link} target="_blank">Entry {index + 1}</a>
        <br/>
      </>;
    })}
  </div>;
}

function getContentfulIdFrom(dataPathsMetadata, node) {
  return (dataPathsMetadata[node.path] || {}).contentful_id 
  || (dataPathsMetadata[node.parentPath] || {}).contentful_id;
}

